export default {
  bays: state => state.bays,
  bay: state => state.bay,
  slots: state => state.slots,
  selectedSlot: state => state.selectedSlot
}



// WEBPACK FOOTER //
// ./src/store/modules/bays/getters.js